<template>
  <div>
      <div class="centerx">
      <vs-popup class="holamundo"  v-bind:title="'Ajuda - Cadastro da Edificação'" :active.sync="popupActivo">
          <div v-html="textoAjuda">
            
          </div>
      </vs-popup>
    </div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro da empresa</h4>
      <div class="badge bagde-default"
      @click="popupActivo =true"
       style="position:absolute; top:17px; right:15px;">Ajuda <i class="fa fa-question-circle"></i></div>
    </div>

    <ul
      class="process-steps row ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
      role="tablist"
    >
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Edificacao'}"
        role="tab"
        tabindex="0"
        aria-controls="ptab1"
        aria-labelledby="ui-id-1"
        aria-selected="true"
        aria-expanded="true"
      >
        <a
          @click.prevent="fnEtapa('Edificacao')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-1"
        >1</a>
        <h6>Dados da edificação</h6>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Areas'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab4"
        aria-labelledby="ui-id-4"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Areas')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-4"
        >2</a>
        <h6>Áreas</h6>
      </li>      
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Administracao'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Administracao')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-2"
        >3</a>
        <h6>Setores Administrativos</h6>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Operacional'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Operacional')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-3"
        >4</a>
        <h6>Setores Operacionais</h6>
      </li>
    </ul>
    <div class="card">
      <form style="padding:15px;" v-if="etapa =='Edificacao'" autocomplete="off">
        <h4 class="mb-3">Dados da edificação</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-endereco">Endereço físico - Sede</label>
            <p class="help small mb-0">Se difirente do endereço da empresa</p>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.logradouro"
              id="_form-Logradouro"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Tipo">Tipo</label>
            <select class="form-control" v-model="cadastro.tipo" id="_form-Tipo">
              <option value=""></option>
              <option value="Alameda">Alameda</option>
              <option value="Avenida">Avenida</option>
              <option value="Chácara">Chácara</option>
              <option value="Condomínio">Condomínio</option>
              <option value="Distrito">Distrito</option>
              <option value="Estrada">Estrada</option>
              <option value="Loteamento">Loteamento</option>
              <option value="Pátio">Pátio</option>
              <option value="Quadra">Quadra</option>
              <option value="Residencial">Residencial</option>
              <option value="Rodovia">Rodovia</option>
              <option value="Rua">Rua</option>
              <option value="Setor">Setor</option>
              <option value="Travessa">Travessa</option>
              <option value="Via">Via</option>
              <option value="vila">Vila</option>
            </select>

          </div>
          <div class="form-group col-md-4">
            <label for="_form-Quadra">Quadra</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.quadra"
              id="_form-Quadra"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Bloco">Bloco</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.bloco"
              id="_form-Bloco"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Lote">Lote</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.lote"
              id="_form-Lote"
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Numero">Número</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.numero"
              id="_form-Numero"
              maxlength="10"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Complemento">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.complemento"
              id="_form-Complemento"
              maxlength="50"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="_form-CEP">CEP</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.cep"
              id="_form-CEP"
              maxlength="8"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Bairro">Bairro</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.bairro"
              id="_form-Bairro"
              maxlength="50"
              required
            />
          </div>
           <div class="form-group col-md-2">
            <label for="_form-UF">UF</label>
              <vs-select
                id="_form-UF"
                placeholder="Selecione um estado"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.estado"
                style="width:100%"
                @change="fnCidade()"
                >
                <vs-select-item :key="index" :value="item.sigla" :text="item.nome" v-for="(item,index) in estados" />
              </vs-select>   
          </div>
          <div class="form-group col-md-4">
            <label for="_form-Cidade">Cidade</label>
                  <vs-select
                id="_form-UF"
                placeholder="Selecione uma cidade"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.cidade"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.nome" :text="item.nome" v-for="(item,index) in cidades" />
              </vs-select>   
          </div>


          <div class="form-group col-md-12">
            <label for="_form-link">Link Google Maps</label>
            <textarea class="form-control" id="_form-link" v-model="cadastro.linkGoogleMaps"></textarea>
          </div>
          <div class="form-group col-md-12 pl-2">
            <label for="_form-link">Fotos externas</label>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="cadastro.foto1? 'ativo':''"
              @click="$refs.file1cadastro.click()"
              :style="cadastro.foto1 && carregado? 'background:url(' + cadastro.foto1+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file1cadastro"
                name="foto"
                ref="file1cadastro"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="cadastro.foto1"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('cadastro',1)"
            >Remover foto</button>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="cadastro.foto2? 'ativo':''"
              @click="$refs.file2cadastro.click()"
              :style="cadastro.foto2 && carregado? 'background:url(' + cadastro.foto2+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file2cadastro"
                name="foto"
                ref="file2cadastro"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="cadastro.foto2"
              type="button"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('cadastro',2)"
            >Remover foto</button>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="cadastro.foto3? 'ativo':''"
              @click="$refs.file3cadastro.click()"
              :style="cadastro.foto3 && carregado? 'background:url(' + cadastro.foto3+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file3cadastro"
                name="foto"
                ref="file3cadastro"
                style="display: none; "
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="cadastro.foto3"
              type="button"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('cadastro',3)"
            >Remover foto</button>
          </div>
          <div class="col-sm-12">
            <hr/>
          </div>
          <div class="col-md-3 form-group">
            <label>Sede alugada:</label>
            <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
              <label
                class="btn btn-outline-secondary ls0 nott"
                id="ativo"
                :class="{'active': cadastro.sedeAlugada == true}"
              >
                <input
                  type="radio"
                  name="ativo"
                  id="ativo"
                  @click="mudaSede(true)"
                  autocomplete="off"
                  class="valid"
                /> Sim
              </label>
              <label
                class="btn btn-outline-secondary ls0 nott"
                id="inativo"
                :class="{'active': cadastro.sedeAlugada == false}"
              >
                <input
                  type="radio"
                  name="ativo"
                  id="inativo"
                  @click="mudaSede(false)"
                  autocomplete="off"
                  class="valid"
                /> Não
              </label>
            </div>
          </div>
          <div class="form-group col-md-9">
            <label for="_form-proprietario">Nome do proprietário</label>
            <input
              type="text"
              class="form-control"
              v-model="cadastro.proprietario"
              id="_form-proprietario"
              maxlength="99"
              required
            />
          </div>
          <div class="col-md-3 form-group">
            <label>Contrato comodato:</label>
            <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
              <label
                class="btn btn-outline-secondary ls0 nott"
                id="ativo"
                :class="{'active': cadastro.contratoComodato == true}"
              >
                <input
                  type="radio"
                  name="ativo"
                  id="ativo"
                  @click="mudaContrato(true)"
                  autocomplete="off"
                  class="valid"
                /> Sim
              </label>
              <label
                class="btn btn-outline-secondary ls0 nott"
                id="inativo"
                :class="{'active': cadastro.contratoComodato == false}"
              >
                <input
                  type="radio"
                  name="ativo"
                  id="inativo"
                  @click="mudaContrato(false)"
                  autocomplete="off"
                  class="valid"
                /> Não
              </label>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label for="_form-mercadoImovel">Valor do mercado do imóvel 
            </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercadoImovel"
              id="_form-mercadoImovel"
              required
              separator="."
              currency="R$"
            />
          </div>

          <div class="form-group col-md-5">
            <label for="_form-iAluguel">
            Valor do mercado do aluguel do imóvel 

          </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercadoImovelAluguel"
              id="_form-iAluguel"
              required
              separator="."
              currency="R$"
            />
          </div>
         <div class="form-group col-md-6">
            <label for="_form-valorCondominio">Valor do condomínio            
            </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorCondominio"
              id="_form-valorCondominio"
              required
              separator="."
              currency="R$"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-vAluguel">Valor do aluguel (se pago)
              </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorAluguel"
              id="_form-vAluguel"
              required
              separator="."
              currency="R$"
            />
          </div>
          <div class="col-sm-12"></div>
          <div class="form-group col-md-4">
            <label for="_form-areaTerreno">Área do terreno do imóvel
            </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaTerreno"
              id="_form-areaTerreno"
              required
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-areaConstruida">Área construida do imóvel
                     
            </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaContruida"
              id="_form-areaConstruida"
              required
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-areaUtil">Área útil total do imóvel
            </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.areaUtil"
              id="_form-areaUtil"
              required
              separator="."
            />
          </div>
          <div class="col-sm-12"></div>
          
          <div class="col-sm-12"></div>
        </div>
        <div style="display: flex; jusify-content:flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fnCadastra">Salvar</button>
        </div>
      </form>
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Administracao'">
        <h4 class="mb-3">Setores administrativos
        </h4>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="_form-periodo">Setores</label>
                <vs-select
                id="_form-periodo"
                placeholder="Selecione o setor"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="administracao.setorId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.setorId" :text="item.titulo" v-for="(item,index) in setoresadministracoes" />
              </vs-select>    

              <div class="form-group mt-2" v-if="administracao.setorId == 0">
                <label>Outro</label>
                <input type="text" name="outroAdministrativo" v-model="outroAdministrativo" class="form-control">
              </div>
          </div>
          <div class="form-group col-md-6">
            <label for="_form-periodo">Área</label>
            <select
              class="form-control"
              id="_form-periodo"
              required
              v-model="administracao.etapaARids"
              multiple
            >
              <option value selected></option>
              <option
                :key="i"
                v-for="(item,i) in areasR"
                :value="item.etapaARid"
              >{{item.nome}}</option>
            </select>
          </div>
          <div class="form-group col-md-12">
              <label> Pessoas ocupam diariamente o mesmo
espaço simultaneamente</label>
              <div style="width:20%;">
              <input
                type="text"
                id="pessoas"
                name="pessoas"
                v-model="administracao.pessoas"

                ref="pessoas"
                class="form-control "
              />

            </div>
            </div>
       
  
          <div class="col-sm-12"></div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="administracao.foto1? 'ativo':''"
              @click="$refs.file1administracao.click()"
              :style="administracao.foto1 && carregado? 'background:url(' + administracao.foto1+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file1administracao"
                name="foto"
                ref="file1administracao"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <div>
              <label>Título foto 1</label>
              <input
                type="text"
                id="tituloFoto1"
                name="tituloFoto1"
                v-model="administracao.tituloFoto1"

                ref="tituloFoto1"
                class="form-control"
              />

            </div>
            <button
              v-if="administracao.foto1"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('administracao',1)"
            >Remover foto</button>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="administracao.foto2? 'ativo':''"
              @click="$refs.file2administracao.click()"
              :style="administracao.foto2 && carregado? 'background:url(' + administracao.foto2+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file2administracao"
                name="foto"
                ref="file2administracao"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
             <div>
              <label>Título foto 2</label>
              <input
                type="text"
                id="tituloFoto2"
                name="tituloFoto2"
                v-model="administracao.tituloFoto2"

                ref="tituloFoto2"
                class="form-control"
              />

            </div>
           <button
              v-if="administracao.foto2"
              type="button"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('administracao',2)"
            >Remover foto</button>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="administracao.foto3? 'ativo':''"
              @click="$refs.file3administracao.click()"
              :style="administracao.foto3 && carregado? 'background:url(' + administracao.foto3+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file3administracao"
                name="foto"
                ref="file3administracao"
                style="display: none; "
                class="form-control"
                accept="image/*"
              />
            </div>
             <div>
              <label>Título foto 3</label>
              <input
                type="text"
                id="tituloFoto3"
                name="tituloFoto3"
                v-model="administracao.tituloFoto3"

                ref="tituloFoto3"
                class="form-control"
              />

            </div>
            <button
              v-if="administracao.foto3"
              type="button"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('administracao',3)"
            >Remover foto</button>
          </div>
        </div>
        <div class="pt-2" style="display: flex; jusify-content:flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fnCadastraAdministracao">Salvar</button>
        </div>
        <hr />
        <div class="row" v-show="filterAdministracoes">
          <h4 class="col-sm-12">Setores cadastrados</h4>
          <div
            class="col-md-12"
            v-for="(item, i) in filterAdministracoes"
            :key="i"
            style="margin-bottom:30px;"
          >
            <div class="card">
              <div class="card-header"></div>
              <div class="card-body">
                <p class="card-text">
                  <span>
                    Setor:
                    <b>
                      <i>{{fnConcat(item.setorId)}}</i>
                    </b>
                  </span>
                  <br />
                </p>
                <p class="card-text mb-1" v-if="item.etapaARids != null && item.etapaARids != ''">
                  <span>
                    Área(s):
                    <b  style="display:block;" :key="i" v-for="(sitem,i) in item.etapaARids">
                      <i> {{fnConcatArea(sitem)}}</i>
                    </b>
                  </span>
                </p>
              </div>
              <div style="padding:15px;">
                <div class="row">
                    <div class="col-sm-4"><img :src="item.foto1" class="img-fluid"><h5>{{item.tituloFoto1}}</h5></div>
                    <div class="col-sm-4"><img :src="item.foto2" class="img-fluid"><h5>{{item.tituloFoto2}}</h5></div>
                    <div class="col-sm-4"><img :src="item.foto3" class="img-fluid"><h5>{{item.tituloFoto3}}</h5></div>
                </div>
              </div>
              <div style="display: flex; jusify-content:flex-end;padding:0 15px 15px 15px;">
                <button
                  type="button"
                  class="btn btn-danger mr-auto"
                  @click="fnDeletar(item.etapaAid)"
                >Deletar</button>
                <button type="button" class="btn btn-success ml-auto" @click="fnEditar(i)">Editar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Operacional'">
        <h4 class="mb-3">Setores operacionais
            <i
            @click="textoAjuda= servico.textoAjudaOperacionaisE03, tituloAjuda = ' Ajuda: Setores operacionais', popupActivo =true"
            v-if="servico.textoAjudaOperacionaisE03 != null && servico.textoAjudaOperacionaisE03 != ''" 
            class="icon-question-circle text-primary"
            style="font-size:14px"
            >
            </i>

        </h4>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="_form-periodo">Setores</label>
                <vs-select
                id="_form-periodo"
                placeholder="Selecione o setor"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="operacional.setorId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.setorId" :text="item.titulo" v-for="(item,index) in setoresoperacionais" />
              </vs-select>    

              <div class="form-group mt-2" v-if="operacional.setorId == 0">
                <label>Outro</label>
                <input type="text" name="outroOperacional" v-model="outroOperacional" class="form-control">
              </div>

          </div>
          <div class="form-group col-md-6">
            <label for="_form-periodo">Área</label>
            <select
              class="form-control"
              id="_form-periodo"
              required
              v-model="operacional.etapaARids"
              multiple
            >
              <option value selected></option>
              <option
                :key="i"
                v-for="(item,i) in areasR"
                :value="item.etapaARid"
              >{{item.nome}}</option>
            </select>
          </div>


          <div class="form-group col-md-7">
            <label for="_form-qtdes">QUANTIDADE MÁXIMA DE VEÍCULOS EM SERVIÇO (QUALQUER)
SIMULTANEO</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="operacional.qtdeVeiculosServico"
              id="_form-qtdes"
              required
            />
          </div>
          <div class="form-group col-md-5">
            <label for="_form-qtdet">Quantidade de vagas de transição.</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="operacional.qtdeVagasTransicao"
              id="_form-qtdet"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-qtdev">Quantidade de vagas de estacionamento se tiver</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="operacional.qtdeVagasEstacionamento"
              id="_form-qtdev"
              required
            />
          </div>
          <div class="col-md-6 form-group">
            <label>Possui área para guarda de veículos</label>
            <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
              <label
                class="btn btn-outline-secondary ls0 nott"
                id="ativo"
                :class="{'active': operacional.guardaVeiculos == true}"
              >
                <input
                  type="radio"
                  name="ativo"
                  id="ativo"
                  @click="mudaGuardaVeiculos(true)"
                  autocomplete="off"
                  class="valid"
                /> Sim
              </label>
              <label
                class="btn btn-outline-secondary ls0 nott"
                id="inativo"
                :class="{'active': operacional.guardaVeiculos == false}"
              >
                <input
                  type="radio"
                  name="ativo"
                  id="inativo"
                  @click="mudaGuardaVeiculos(false)"
                  autocomplete="off"
                  class="valid"
                /> Não
              </label>
            </div>
          </div>
          <div class="form-group col-md-4" v-show="operacional.guardaVeiculos">
            <label for="_form-qtde">Quantidade de veículos</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="operacional.qtdeVagasSetor"
              id="_form-qtde"
              required
            />
          </div>
          <div class="col-sm-12"></div>
          <div class="col-sm-4 text-center">
           <div
              class="areaFoto"
              :class="operacional.foto1? 'ativo':''"
              @click="$refs.file1operacional.click()"
              :style="operacional.foto1 && carregado? 'background:url(' + operacional.foto1+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file1operacional"
                name="foto"
                ref="file1operacional"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
             <div>
              <label>Título foto1</label>
              <input
                type="text"
                id="operacionaltituloFoto1"
                name="operacionaltituloFoto1"
                v-model="operacional.tituloFoto1"

                ref="operacionaltituloFoto1"
                class="form-control"
              />

            </div>

            <button
              v-if="operacional.foto1"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('operacional',1)"
            >Remover foto</button>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="operacional.foto2? 'ativo':''"
              @click="$refs.file2operacional.click()"
              :style="operacional.foto2 && carregado? 'background:url(' + operacional.foto2+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file2operacional"
                name="foto"
                ref="file2operacional"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <div>
              <label>Título foto 2</label>
              <input
                type="text"
                id="operacionaltituloFoto2"
                name="operacionaltituloFoto2"
                v-model="operacional.tituloFoto2"

                ref="operacionaltituloFoto2"
                class="form-control"
              />

            </div>

           <button
              v-if="operacional.foto2"
              type="button"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('operacional',2)"
            >Remover foto</button>
          </div>
          <div class="col-sm-4 text-center">
            <div
              class="areaFoto"
              :class="operacional.foto3? 'ativo':''"
              @click="$refs.file3operacional.click()"
              :style="operacional.foto3 && carregado? 'background:url(' + operacional.foto3+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file3operacional"
                name="foto"
                ref="file3operacional"
                style="display: none; "
                class="form-control"
                accept="image/*"
              />
            </div>
            <div>
              <label>Título foto 3</label>
              <input
                type="text"
                id="operacionaltituloFoto3"
                name="operacionaltituloFoto3"
                v-model="operacional.tituloFoto3"

                ref="operacionaltituloFoto3"
                class="form-control"
              />

            </div>
            <button
              v-if="operacional.foto3"
              type="button"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('operacional',3)"
            >Remover foto</button>
          </div>
        </div>

        <div style="display: flex; jusify-content:flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fnCadastraOp">Salvar</button>
        </div>
        <hr />
        <div class="row" v-show="filterOperacionais">
          <h4 class="col-sm-12">Setores cadastrados</h4>
          <div
            class="col-md-12"
            v-for="(item, i) in filterOperacionais"
            :key="i"
            style="margin-bottom:30px;"
          >
            <div class="card">
              <div class="card-header">{{fnConcatOp(item.setorId)}}</div>
              <div class="card-body">
                <p class="card-text mb-1" v-if="item.etapaARids.length > 0">
                  <span>
                    Área(s):
                    <b  style="display:block;" :key="i" v-for="(sitem,i) in item.etapaARids">
                      <i> {{fnConcatArea(sitem)}}</i>
                    </b>
                  </span>
                </p>
                <p class="card-text mb-1">
                  <span>
                    Qtde. vagas estacionamento:
                    <b>
                      <i>{{item.qtdeVagasEstacionamento}}</i>
                    </b>
                  </span>
                  <br />
                </p>
                <p class="card-text mb-1">
                  <span>
                    Qtde. vagas de transição:
                    <b>
                      <i>{{item.qtdeVagasTransicao}}</i>
                    </b>
                  </span>
                  <br />
                </p>
                <p class="card-text mb-1">
                  <span>
                    Qtde. total de veículos em serviço:
                    <b>
                      <i>{{item.qtdeVeiculosServico}}</i>
                    </b>
                  </span>
                  <br />
                </p>
                <p class="card-text mb-1">
                  <span>
                    Quarda veículos:
                    <b>
                      <i
                        :class="item.guardaVeiculos ? 'icon-checkbox-checked':'icon-times-circle1'"
                      ></i>
                    </b>
                  </span>
                  <br />
                </p>
                <p class="card-text mb-1" v-show="item.guardaVeiculos">
                  <span>
                    Qtde. veículos no setor:
                    <b>
                      <i>{{item.qtdeVagasSetor}}</i>
                    </b>
                  </span>
                  <br />
                </p>

              </div>
              <div style="padding:15px;">
                <div class="row">
                    <div class="col-sm-4" v-if="item.foto1"><img :src="item.foto1" class="img-fluid"><h5>{{item.tituloFoto1}}</h5></div>
                    <div class="col-sm-4" v-if="item.foto2"><img :src="item.foto2" class="img-fluid"><h5>{{item.tituloFoto2}}</h5></div>
                    <div class="col-sm-4" v-if="item.foto3"><img :src="item.foto3" class="img-fluid"><h5>{{item.tituloFoto3}}</h5></div>
                </div>
              </div>

              <div style="display: flex; jusify-content:flex-end;padding:0 15px 15px 15px;">
                <button
                  type="button"
                  class="btn btn-danger mr-auto"
                  @click="fnDeletarB(item.etapaAid)"
                >Deletar</button>
                <button type="button" class="btn btn-success ml-auto" @click="fnEditarOp(i)">Editar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Areas'">


        <div v-if="!areaLiberada" class="alert alert-danger">
          A soma de todas as áreas devem ser igual a área útil total. ({{areaCadastrada}}m² de {{cadastro.areaUtil}}m²)
        </div>
        <h4 class="mb-3">Áreas 
                    <i
            @click="textoAjuda= servico.textoAjudaAreaE03, tituloAjuda = ' Ajuda: Áreas', popupActivo =true"
            v-if="servico.textoAjudaAreaE03 != null && servico.textoAjudaAreaE03 != ''" 
            class="icon-question-circle text-primary"
            style="font-size:14px"
            >
            </i>

        </h4>
        <div class="form-row">

          <div class="form-group col-md-5">
            <label for="_form-area">Nome da área</label>
            <input 
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="areas.nome"
              id="_form-area"
              required
            />
          </div>
          <div class="form-group col-md-5">
            <label for="_form-area">Área em m2</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="areas.area"
              id="_form-area"
              required
              separator="."
            />
          </div>
          <div class="col-sm-12"></div>
          <div class="col-sm-4 text-center">
           <div
              class="areaFoto"
              :class="areas.foto1? 'ativo':''"
              @click="$refs.file1areas.click()"
              :style="areas.foto1 && carregado? 'background:url(' + areas.foto1+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="file1areas"
                name="foto"
                ref="file1areas"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="areas.foto1"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('areas',1)"
            >Remover foto</button>
          </div>
        </div>

        <div style="display: flex; jusify-content:flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fnCadastraAreas">Salvar</button>
        </div>
        <hr />
        <div class="row" v-show="areasR.length > 0">
          <h4 class="col-sm-12">Áreas cadastradas</h4>
          <div
            class="col-md-12"
            v-for="(item, i) in areasR"
            :key="i"
            style="margin-bottom:30px;"
          >
            <div class="card">
              <div class="card-body">
                <p class="card-text mb-1">
                  <span>
                    Nome:
                    <b>
                      <i>{{item.nome}}</i>
                    </b>
                  </span>
                  <br />
                </p>
                <p class="card-text mb-1">
                  <span>
                    Área
                    <b>
                      <i>{{item.area}}</i>
                    </b>
                  </span>
                  <br />
                </p>
              </div>
              <div style="padding:15px;">
                <div class="row">
                    <div class="col-sm-4" v-if="item.foto1"><img :src="item.foto1" class="img-fluid"><h5>{{item.tituloFoto1}}</h5></div>
                </div>
              </div>

              <div style="display: flex; jusify-content:flex-end;padding:0 15px 15px 15px;">
                <button
                  type="button"
                  class="btn btn-danger mr-auto"
                  @click="fnDeletarArea(item.etapaARid)"
                >Deletar</button>
                <button type="button" class="btn btn-success ml-auto" @click="fnEditarArea(i)">Editar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <p v-for="(item,i) in administracaoFotos" :key="i">{{item.name}}</p>
        <div style="display: none">
      {{ carregadoImg }}
    </div>
  </div>
</template>

<script>
import { getSuccess, clientKey, urlApi } from "../../../global/utils";

export default {
  data() {
    return {
      cadastro: {
        sedeAlugada: false,
        contratoComodato: false,
        contratacaoId: null,
      },
      administracoes: [],
      estados:[],
      cidades:[],
      setoresadministracoes: {},
      setoresoperacionais: {},
      setoresE03A: [],
      operacionais: [],
      areasR: [],
      areas: {},
      servico: {},
      carregadoIm: false,
      areaLiberada: false,
      administracao: {
        guardaVeiculos: false,
        etapaId: null,
        administrativo: true,
        etapaARids: [],
        foto1:null,
        foto2:null,
        foto3:null
      },
      operacional: {
        etapaId: null,
        guardaVeiculos: false,
        administrativo: false,
        etapaARids: [],
       foto1:null,
        foto2:null,
        foto3:null
     },
      mudouEstado:false,
      cadastroId: null,
      areaCadastrada: 0,
      contrato: {},
      etapa: "Edificacao",
      colorAlert:'primary',
      titleAlert:'Alert',
      popupActivo:false,
      tituloAjuda: "",
      textoAjuda: "",
      cadastroFotos: [],
      areasFotos: [],
      administracaoFotos: [],
      operacionalFotos: [],
      suporteFoto: [],
      selectedFile: null,
      files: [],
      carregado: true,
      active: true,
      outroAdministrativo: "",
      outroOperacional: ""
    };
  },
  mounted() {
    //this.fnGetPorte()
    this.fnGetOperacional();
    this.fnGetAdministracao();
    this.fnGetContratacao();
    this.fnEstados();
  },
  methods: {
    OnFileSelected(event) {
      if (event.target.id == "file1cadastro") {
        this.cadastro.foto1 = URL.createObjectURL(event.target.files[0]);
        this.cadastroFotos.push(event.target.files[0]);
      } else if (event.target.id == "file2cadastro") {
        this.cadastro.foto2 = URL.createObjectURL(event.target.files[0]);
        this.cadastroFotos.push(event.target.files[0]);
      } else if (event.target.id == "file3cadastro") {
        this.cadastro.foto3 = URL.createObjectURL(event.target.files[0]);
        this.cadastroFotos.push(event.target.files[0]);
      }else if (event.target.id == "file1administracao") {
        this.administracao.foto1 = URL.createObjectURL(event.target.files[0]);
        this.administracaoFotos.push(event.target.files[0]);
      } else if (event.target.id == "file2administracao") {
        this.administracao.foto2 = URL.createObjectURL(event.target.files[0]);
        this.administracaoFotos.push(event.target.files[0]);
      } else if (event.target.id == "file3administracao") {
        this.administracaoFotos.push(event.target.files[0]);
        this.administracao.foto3 = URL.createObjectURL(event.target.files[0]);
      }else if (event.target.id == "file1operacional") {
        this.operacional.foto1 = URL.createObjectURL(event.target.files[0]);
        this.operacionalFotos.push(event.target.files[0]);
      } else if (event.target.id == "file2operacional") {
        this.operacional.foto2 = URL.createObjectURL(event.target.files[0]);
        this.operacionalFotos.push(event.target.files[0]);
      } else if (event.target.id == "file3operacional") {
        this.operacionalFotos.push(event.target.files[0]);
        this.operacional.foto3 = URL.createObjectURL(event.target.files[0]);
      }else if (event.target.id == "file1areas") {
        this.areasFotos.push(event.target.files[0]);
        this.areas.foto1 = URL.createObjectURL(event.target.files[0]);
      }
      this.carregadoIm = true;
    },
    fnRemoveFoto(tipo, i) {
      var filename = '';
      var etapa = '';
      if (tipo == "cadastro") {
        etapa = "etapa03"
        if (i == 1) {
        
          filename = this.cadastro.foto1.split('/').pop().split('#')[0].split('?')[0]
          this.cadastro.foto1 = null;
        } else if (i == 2) {
           filename = this.cadastro.foto2.split('/').pop().split('#')[0].split('?')[0]
          this.cadastro.foto2 = null;
       } else {
           filename = this.cadastro.foto3.split('/').pop().split('#')[0].split('?')[0]
          this.cadastro.foto3 = null;
       }
      }
      if (tipo == "administracao") {
        etapa = "etapa03A"
        if (i == 1) {
          this.administracao.foto1 = null;
          filename = this.administracao.foto1.split('/').pop().split('#')[0].split('?')[0]
      } else if (i == 2) {
           filename = this.administracao.foto2.split('/').pop().split('#')[0].split('?')[0]
          this.administracao.foto2 = null;
       } else {
          filename = this.administracao.foto3.split('/').pop().split('#')[0].split('?')[0]
          this.administracao.foto3 = null;
        }
      }
      if (tipo == "operacional") {
        etapa = "etapa03B"
        if (i == 1) {
          this.operacional.foto1 = null;
           filename = this.operacional.foto1.split('/').pop().split('#')[0].split('?')[0]
       } else if (i == 2) {
            filename = this.operacional.foto2.split('/').pop().split('#')[0].split('?')[0]
         this.operacional.foto2 = null;
        } else {
            filename = this.operacional.foto3.split('/').pop().split('#')[0].split('?')[0]
          this.operacional.foto3 = null;
        }
      } 
      if (tipo == "areas") {
        etapa = "etapa03AR"
        if (i == 1) {
           filename = this.areas.foto1.split('/').pop().split('#')[0].split('?')[0]
          this.areas.foto1 = null;
       } 
      }
      this.carregadoIm = false;
      this.$http
        .delete("api/img/" + this.$route.params.codigoContrato + "/" + etapa+"/"+filename+"/arquivo")
        .then((res) => {
          console.log(res);
        });

    },
   GetFilename(url)
    {
      if (url)
      {
          var m = url.toString().match(/.*\/(.+?)\./);
          if (m && m.length > 1)
          {
            return m[1];
          }
      }
      return "";
    },
    async fnEstados(){
      this.$http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
      .then((res) => {
        var estados = res.data
        console.log(estados.sort(function (a, b) {
          console.log(a.nome);
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          // a must be equal to b
          return 0;
        }))
        this.estados = estados;
      });
    },
    async fnCidade(){
      await  this.$http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados/"+this.cadastro.estado+"/municipios")
        .then((res) => {
          var cidades = res.data
          console.log(cidades.sort(function (a, b) {
            console.log(a.nome);
            if (a.nome > b.nome) {
              return 1;
            }
            if (a.nome < b.nome) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }))
          this.cidades = cidades;
        });

    },
    async OnUpload(etapa) {
         this.carregadoIm = false;

      var self = this;
      let fd = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = self.files[i];
        fd.append("files", file, file.name);
      }
      await this.$http
        .post("api/img/" + this.$route.params.codigoContrato + "/" + etapa, fd)
        .then(() => {
          this.carregado = true;
          this.files = [];
          this.administracoesFotos = [];
          this.operacionaisFotos = [];
          this.cadastroFotos = [];
          this.areasFotos = [];
         this.carregadoIm = true;

        });
    },
    mudaSede(val) {
      if (this.cadastro.sedeAlugada != val) {
        this.cadastro.sedeAlugada = !this.cadastro.sedeAlugada;
      }
    },
    mudaGuardaVeiculos(val) {
      if (this.operacional.guardaVeiculos != val) {
        this.operacional.guardaVeiculos = !this.operacional.guardaVeiculos;
      }
    },
    mudaContrato(val) {
      if (this.cadastro.contratoComodato != val) {
        this.cadastro.contratoComodato = !this.cadastro.contratoComodato;
      }
    },
    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_03`)
        .then((res) => {
          this.cadastro.contratacaoId = res.data.contratacaoId;
          this.cadastroId = res.data.contratacaoId;
          if (res.data.contratacoesEVO03 != null) {
            this.cadastro = res.data.contratacoesEVO03;
          }
          if (res.data.contratacoesEVO03.contratacoesEVO03A != null) {
            let itemAdmin = res.data.contratacoesEVO03.contratacoesEVO03A;
            this.setoresE03A = itemAdmin;
          }
          if (res.data.contratacoesEVO03.contratacoesEVO03A != null) {
            let itemAdminAreas = res.data.contratacoesEVO03.contratacoesEVO03AR;
            this.areasR = itemAdminAreas;
            var areasTotal = 0;
            this.areasR.forEach(element => {
              areasTotal += element.area;
            });
            this.areaCadastrada = areasTotal;
          }
        })
        .catch(() => {});
            await this.$http.get(`contratacao/lista/${this.$route.params.codigoContrato}`)
            .then(res=>{
                this.servico = res.data.servicos
                this.textoAjuda =  this.servico.textoAjuda03;

            })

    },

    async fnGetAdministracao() {
      await this.$http
        .get("listasetores/api/administracao")
        .then((res) => {
          this.setoresadministracoes = res.data;
          this.setoresadministracoes.push({setorId: 0 , titulo: "Outros"})
        })
        .catch(() => {});
    },
    async fnGetOperacional() {
      await this.$http
        .get("listasetores/api/operacional")
        .then((res) => {
          this.setoresoperacionais = res.data;
           this.setoresoperacionais.push({setorId: 0 , titulo: "Outros"})
       })
        .catch(() => {});
    },

    async fnCadastra(e) {
      e.preventDefault();
      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa03/";
      const metodo = this.cadastro.etapaId ? "put" : "post";
      this.cadastro.tsAlteracao = this.cadastro.etapaId
        ? this.$moment().format()
        : null;
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "";
      if(this.cadastro.etapaId != null){
        delete this.cadastro['contratacoesEVO03A'];
        delete this.cadastro['contratacoesEVO03AR'];
      }
      if (this.cadastro.foto1 == null) {
        var recebeFoto = "";
        if (this.cadastro.foto2 != null) {
          recebeFoto = this.cadastro.foto2;
          this.cadastro.foto2 = null;
        } else if (this.cadastro.foto3 != null) {
          recebeFoto = this.cadastro.foto3;
          this.cadastro.foto3 = null;
        }
        this.cadastro.foto1 = recebeFoto;
      }
      if (this.cadastro.foto2 == null) {
        if (this.cadastro.foto3 != null) {
          this.cadastro.foto2 = this.cadastro.foto3;
          this.cadastro.foto3 = null;
        } else {
          this.cadastro.foto2 = null;
        }
      }
      this.carregado = false;
      let foto1 = this.cadastro.foto1;
      let foto2 = this.cadastro.foto2;
      let foto3 = this.cadastro.foto3;
      let pulafoto1 = false;
      let pulafoto2 = false;
      let pulafoto3 = false;
      for (var i = 0; i < this.cadastroFotos.length; i++) {
        
        if (foto1.search(imgUrl) < 0 && !pulafoto1) {
          this.cadastro.foto1 = imgUrl + this.cadastroFotos[i].name;
          pulafoto1 = true;
          this.files.push(this.cadastroFotos[i]);
          continue;
        }
        if (foto2 != null && foto2.search(imgUrl) < 0 && !pulafoto2) {
          this.cadastro.foto2 = imgUrl + this.cadastroFotos[i].name;
          pulafoto2 = true;
          this.files.push(this.cadastroFotos[i]);
          continue;
        }
        if (foto3 != null && foto3.search(imgUrl) < 0 && !pulafoto3) {
          this.cadastro.foto3 = imgUrl + this.cadastroFotos[i].name;
          pulafoto3 = true;
          this.files.push(this.cadastroFotos[i]);
          continue;
        }
     
      }
      if(this.cadastroFotos.length > 0)
      {
        await this.OnUpload("etapa03");
      }  
      await this.$http[metodo]("/etapa_03" + completaUrl, this.cadastro)
        .then((res) => {
          if (metodo == "post") {
            this.cadastro = res.data;
          }
           getSuccess();
           this.fnGetContratacao();
        })
        .catch(() => {});
    },
    fnEtapa(val) {
      if (this.cadastro.etapaId == undefined) {
        if (val == "Administracao" || val == "Operacional" || val == "Areas") {
          this.$toasted.global.defaultInfo({
            msg: "Finalize os dados das obrigações e das áreas da edificação.",
          });
        }
      } else {
          var areaUtil = this.cadastro.areaUtil;
          var areasTotal = 0;
          this.areasR.forEach(element => {
            areasTotal += element.area;
          });

          this.areaLiberada = this.areasR.length > 0 && Number(areasTotal) == Number(areaUtil);

          if (!this.areaLiberada && (val == "Administracao" || val == "Operacional")) {
           this.$toasted.global.defaultInfo({
            msg: `Preencha as áreas da edificação. O total deve ser equivalente a ${this.cadastro.areaUtil}m².`,
          });
         }
          else{
            this.etapa = val;
          }
      }
    },
    async fnCadastraAdministracao(e) {
      e.preventDefault();
      const metodo = this.administracao.etapaAid ? "put" : "post";
      this.administracao.tsAlteracao = this.administracao.etapaAid
        ? this.$moment().format()
        : null;
      const completaUrl = this.administracao.etapaAid
        ? "/" + this.administracao.etapaAid
        : "/" + this.cadastroId;
      this.administracao.etapaId = this.cadastro.etapaId;
      this.administracao.administrativo = true;
      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa03A/";

      if (this.administracao.foto1 == null) {
        var recebeFoto = "";
        if (this.administracao.foto2 != null) {
          recebeFoto = this.administracao.foto2;
          this.administracao.foto2 = null;
        } else if (this.administracao.foto3 != null) {
          recebeFoto = this.administracao.foto3;
          this.administracao.foto3 = null;
        }
        this.administracao.foto1 = recebeFoto;
      }
      if (this.administracao.foto2 == null) {
        if (this.administracao.foto3 != null) {
          this.administracao.foto2 = this.administracao.foto3;
          this.administracao.foto3 = null;
        } else {
          this.administracao.foto2 = null;
        }
      }
      this.carregado = false;
      let foto1 = this.administracao.foto1;
      let foto2 = this.administracao.foto2;
      let foto3 = this.administracao.foto3;
      let pulafoto1 = false;
      let pulafoto2 = false;
      let pulafoto3 = false;
      for (var i = 0; i < this.administracaoFotos.length; i++) {
        this.files.push(this.administracaoFotos[i]);
        if (foto1.search(imgUrl) < 0 && !pulafoto1) {
          this.administracao.foto1 = imgUrl + this.administracaoFotos[i].name;
          pulafoto1 = true;
          continue;
        }
        if (foto2 != null && foto2.search(imgUrl) < 0 && !pulafoto2 ) {
          this.administracao.foto2 = imgUrl + this.administracaoFotos[i].name;
          pulafoto2 = true;
          continue;
        }
        if (foto3 != null && foto3.search(imgUrl) < 0 && !pulafoto3 ) {
          this.administracao.foto3 = imgUrl + this.administracaoFotos[i].name;
          pulafoto3 = true;
          continue;
        }
      }
      if(this.administracaoFotos.length > 0)
      {
        await this.OnUpload("etapa03A");
      }
      let headers = {
        'outroAdministrativo': this.outroAdministrativo,
      };
      await this.$http[metodo]("/etapa_03A" + completaUrl + "?outroAdministrativo="+this.outroAdministrativo, this.administracao,{headers: headers})
        .then((res) => {
          if (metodo == "post") {
            this.setoresE03A.push(res.data);
          }
          this.administracao = {
            qtdeVeiculosServicos: null,
            qtdeVagasEstacionamento: null,
            qtdeVagasTransicao: null,
            guardaVeiculos: false,
            administrativo: true,
            etapaARids: [],
            etapaId: this.cadastro.etapaId,
          };

           getSuccess();
           this.fnGetContratacao();
           window.location.reload(true);
        })
        .catch(() => {});
    },
    async fnCadastraOp(e) {
      e.preventDefault();
      const metodo = this.operacional.etapaAid ? "put" : "post";
      this.operacional.tsAlteracao = this.operacional.etapaAid
        ? this.$moment().format()
        : null;
      const completaUrl = this.operacional.etapaAid
        ? "/" + this.operacional.etapaAid
        : "/" + this.cadastroId;
      this.operacional.etapaId = this.cadastro.etapaId;
      this.operacional.administrativo = false;

      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa03B/";

      if (this.operacional.foto1 == null) {
        var recebeFoto = "";
        if (this.operacional.foto2 != null) {
          recebeFoto = this.operacional.foto2;
          this.operacional.foto2 = null;
        } else if (this.operacional.foto3 != null) {
          recebeFoto = this.operacional.foto3;
          this.operacional.foto3 = null;
        }
        this.operacional.foto1 = recebeFoto;
      }
      if (this.operacional.foto2 == null) {
        if (this.operacional.foto3 != null) {
          this.operacional.foto2 = this.operacional.foto3;
          this.operacional.foto3 = null;
        } else {
          this.operacional.foto2 = null;
        }
      }
      this.carregado = false;
      let foto1 = this.operacional.foto1;
      let foto2 = this.operacional.foto2;
      let foto3 = this.operacional.foto3;
      let pulafoto1 = false;
      let pulafoto2 = false;
      let pulafoto3 = false;
      for (var i = 0; i < this.operacionalFotos.length; i++) {
        if (foto1.search(imgUrl) < 0 && !pulafoto1) {
          this.operacional.foto1 = imgUrl + this.operacionalFotos[i].name;
          pulafoto1 = true;
           this.files.push(this.operacionalFotos[i]);
          continue;
        }
        if (foto2 != null && foto2.search(imgUrl) < 0 && !pulafoto2) {
          this.operacional.foto2 = imgUrl + this.operacionalFotos[i].name;
          pulafoto2 = true;
         this.files.push(this.operacionalFotos[i]);
          continue;
        }
        if (foto3 != null && foto3.search(imgUrl) < 0 && !pulafoto3 ) {
          this.operacional.foto3 = imgUrl + this.operacionalFotos[i].name;
          pulafoto3 = true;
           this.files.push(this.operacionalFotos[i]);
          continue;
        }
      }
      if(this.operacionalFotos.length > 0)
        {
          await this.OnUpload("etapa03B");
        }
        let headers = {
        'outroOperacional': this.outroOperacional,
      };

      await this.$http[metodo]("/etapa_03A" + completaUrl +"?outroOperacional="+ this.outroOperacional, this.operacional,{headers: headers})
        .then((res) => {
          if (metodo == "post") {
            this.setoresE03A.push(res.data);
          }
          this.operacional = {
            qtdeVeiculosServicos: 0,
            qtdeVagasEstacionamento: 0,
            qtdeVagasTransicao: 0,
            guardaVeiculos: false,
            administrativo: false,
            etapaARids: [],
            etapaId: this.cadastro.etapaId,
          };
           getSuccess();
           this.fnGetContratacao();
           window.location.reload(true);

        })
        .catch(() => {});
    },
    async fnCadastraAreas(e) {
      e.preventDefault();
      const metodo = this.areas.etapaARid ? "put" : "post";
      this.areas.tsAlteracao = this.areas.etapaARid
        ? this.$moment().format()
        : null;
      const completaUrl = this.areas.etapaARid
        ? "/" + this.areas.etapaARid
        : "/" ;
      this.areas.etapaId = this.cadastro.etapaId;

      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa03Areas/";

      this.carregado = false;
      let foto1 = this.areas.foto1;
      let pulafoto1 = false;
      for (var i = 0; i < this.areasFotos.length; i++) {
        this.files.push(this.areasFotos[i]);
        if (foto1.search(imgUrl) < 0 && !pulafoto1) {
          this.areas.foto1 = imgUrl + this.areasFotos[i].name;
          pulafoto1 = true;
          continue;
        }
      }
      if(this.areasFotos.length > 0)
        {
        await this.OnUpload("etapa03Areas");
        }
      await this.$http[metodo]("/etapa_03AR" + completaUrl, this.areas)
        .then((res) => {
          if (metodo == "post") {
            this.filterOperacionais.push(res.data);
          }
          this.areas = {
            nome: "",
            foto1: "",
            area: 0,
            etapaId: this.cadastro.etapaId,
          };

           getSuccess();
           this.fnGetContratacao();
        })
        .catch(() => {});
    },
    fnEditar(i) {
      if (this.filterAdministracoes[i].etapaARids == null){
        this.filterAdministracoes[i].etapaARids = [];
      }
      this.administracao = this.filterAdministracoes[i];
    },
    fnEditarOp(i) {
      this.operacional = this.filterOperacionais[i];
    },
    fnEditarArea(i) {
      this.areas = this.areasR[i];
    },
    fnConcat(val) {
      var item = this.setoresadministracoes.filter((administracoes) => {
        return administracoes.setorId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
    },
    fnConcatArea(val) {
      var item = this.areasR.filter((area) => {
        return area.etapaARid == val;
      });
      if (item.length > 0) {
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].nome;
      }
    },
    fnConcatOp(val) {
      var item = this.setoresoperacionais.filter((administracoes) => {
        return administracoes.setorId == val;
      });
      if (item.length > 0) {
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
      }
    },
    fnConcatSetor(val) {
      var item = this.filterOperacionais.filter((administracoes) => {
        return administracoes.etapaAid == val;
      });
      if (item.length > 0) {
        var toString = JSON.stringify(item);
        var toJson = JSON.parse(toString);
        return this.fnConcatOp(toJson[0].setorId);
      }
    },
    fnConcatSetorA(val) {
      if (val != "" && val != undefined) {
        var item = this.filterAdministracoes.filter((administracoes) => {
          return administracoes.etapaAid == val;
        });
        if (item.length > 0) {
          var toString = JSON.stringify(item);
          var toJson = JSON.parse(toString);
          return this.fnConcat(toJson[0].setorId);
        }
      }
    },
    fnVerificaAdminsitracao(val) {
      var item = this.setoresadministracoes.filter((administracoes) => {
        return administracoes.setorId === val;
      });
      if (item.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_03A/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.filterAdministracoes
            .map((item) => item.etapaAid)
            .indexOf(val);
          this.filterAdministracoes.splice(i, 1);
          this.fnGetContratacao();
          getSuccess();
        })
        .catch(() => {});
    },
    async fnDeletarArea(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_03AR/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.areasR
            .map((item) => item.etapaAid)
            .indexOf(val);
          this.areasR.splice(i, 1);
          this.fnGetContratacao();
          getSuccess();
        })
        .catch(() => {});
    },
    async fnDeletarB(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_03A/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.filterOperacionais
            .map((item) => item.etapaAid)
            .indexOf(val);
          this.filterOperacionais.splice(i, 1);
          this.fnGetContratacao();
          getSuccess();
        })
        .catch(() => {});
    },
    fnPopUp(titulo,texto)
    {
      this.tituloAjuda = titulo;
      this.textoAjuda = texto;
      this.popupActivo = true;
    },
  },
  computed: {
    filterOperacionais: function () {
      let data = [];
      for (var i = 0; i < this.setoresE03A.length; i++) {
        var admin = this.fnVerificaAdminsitracao(this.setoresE03A[i].setorId);
        if (admin == false) {
          data.push(this.setoresE03A[i]);
        }
      }
      return data;
    },
    filterAdministracoes: function () {
      let data = [];
      for (var i = 0; i < this.setoresE03A.length; i++) {
        var admin = this.fnVerificaAdminsitracao(this.setoresE03A[i].setorId);
        if (admin == true) {
          data.push(this.setoresE03A[i]);
        }
      }
      return data;
    },
    filterAreas: function () {
      let data = [];
      console.log(this.areasR);
      for (var i = 0; i < this.areasR.length; i++) {
        var admin = this.areasR[i];
        if (admin == false) {
          data.push(this.areasR[i]);
        }
      }
      return data;
    },
    carregadoImg() {
      if (this.carregadoIm) {
        return this.cadastro;
      } else {
        return "";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}

  .con-footer
  {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

    .vs-button{
      margin: 0px

    }
      .vs-button__content{
        padding: 10px 30px
      }
      ~ .vs-button{
        margin-left: 10px

      }
  .not-margin{
    margin: 0px;
    font-weight: normal;
    padding: 10px;
    padding-bottom: 0px;

  }
  .con-content
  {
    width: 100%;

  }
    p{
      font-size: .8rem;
      padding: 0px 10px;
    }
    .vs-checkbox-label
    {
      font-size: .8rem;

    }
    .vs-input-parent
    {
      width: 100%;

    }
    .vs-input-content{
      margin: 10px 0px;
      width: calc(100%);

    }
      .vs-input
      {
        width: 100%;

      }
  .footer-dialog
  {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: calc(100%);

  }
    .new
    {
      margin: 0px;
      margin-top: 20px;
      padding: 0px;
      font-size: .7rem;

    }
      .new a
      {
        color: #007bff !important;
        margin-left: 6px;

      }
       .new a:hover
      {
          text-decoration: underline
      }
    .vs-button{
      margin: 0px

    }
</style>
